const loadingClass = 'loading';

export function startLoadingIndicator() {
  getOverlay().classList.add(loadingClass);
}

export function stopLoadingIndicator() {
  getOverlay().classList.remove(loadingClass);
}

function getOverlay() {
  return document.getElementById('loading-overlay');
}
